var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDrift(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 130 90",
    style: {
      enableBackground: "new 0 0 130 90"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#222222;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2_1_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Drift"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g85"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g75"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Combined-Shape",
    className: "st0",
    d: "M90,45c0,13.8-11.2,25-25,25S40,58.8,40,45c0-13.8,11.2-25,25-25 C78.8,20,90,31.2,90,45z M80.8,38.4c-0.3-0.2-0.7-0.2-1.1,0l-13.4,7.9c-0.3,0.2-0.5,0.5-0.5,0.9v4.1c0,0.6,0.5,1.1,1,1.1 c0.2,0,0.4,0,0.5-0.1l0,0l4.4-2.6v9.6c0,0.4,0.2,0.7,0.5,0.9c0.3,0.2,0.7,0.2,1.1,0l2.7-1.5c0.3-0.2,0.5-0.6,0.5-0.9V46.9 l4.3-2.5c0.3-0.2,0.5-0.5,0.5-0.9v-4.1C81.4,38.9,81.2,38.6,80.8,38.4L80.8,38.4z M66.3,35.9l4.2,2.5c0,0,0,0,0,0.1v3.1 c0,0.2,0.2,0.4,0.4,0.4c0.1,0,0.1,0,0.2-0.1l7.7-4.5c0.2-0.1,0.3-0.4,0.1-0.6c0-0.1-0.1-0.1-0.1-0.1l-11.6-6.8 c-0.5-0.3-1.2-0.1-1.4,0.4c-0.1,0.2-0.1,0.4-0.1,0.5v4.1C65.8,35.3,66,35.7,66.3,35.9z M63.9,29.9c-0.3-0.2-0.7-0.2-1.1,0 l-11.6,6.8c-0.2,0.1-0.3,0.4-0.1,0.6c0,0.1,0.1,0.1,0.1,0.1l7.8,4.5c0.2,0.1,0.5,0,0.6-0.2c0-0.1,0-0.1,0-0.2v-3.1l4.1-2.4 c0.5-0.3,0.7-0.8,0.7-1.3v-3.9C64.4,30.4,64.2,30.1,63.9,29.9z M63.7,46.3l-13.5-7.9c-0.5-0.3-1.2-0.1-1.4,0.4 c-0.1,0.2-0.1,0.4-0.1,0.5v4.1c0,0.4,0.2,0.7,0.5,0.9l4.3,2.5v10.9c0,0.4,0.2,0.7,0.5,0.9l2.7,1.5c0.3,0.2,0.7,0.2,1.1,0 c0.3-0.2,0.5-0.5,0.5-0.9v-9.6l4.4,2.6l0,0c0.3,0.2,0.7,0.2,1,0c0.3-0.2,0.5-0.5,0.5-0.9v-4.1C64.2,46.8,64,46.5,63.7,46.3z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrift);
export default __webpack_public_path__ + "static/media/Drift.c17e32ffd98232ef4f77fe8d9243bf53.svg";
export { ForwardRef as ReactComponent };